import { Divider, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import { useNavigate } from 'react-router-dom';
import OrderDetails from './orderDetails';

const OrderDetailsGlobal = () => {

    const navigate = useNavigate();
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const flagTabletScreen = useMediaQuery('(max-width : 900px) and (min-width : 600px)');

    const innerHeight = (window.innerHeight - 100);

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container sx={{ padding: { xs: "15px 0px", sm: "23px 0px" } }} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={globalStyles.fullwidth} sx={{ padding: { xs: "0px 20px", lg: "5px 25px 0px 27px" } }}>
                                <GlobalPageHeaderText
                                    mainHeadText={"Order Details"}
                                    flagMainTextOnly
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle}`} sx={{ paddingTop: "15px !important" }} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} className={`${globalStyles.overflowAuto}`} sx={{ maxHeight: `${innerHeight}px`, padding: "10px 25px 0 27px" }}>
                        <OrderDetails />
                    </Grid>
                    

                </Grid>
            </Grid>
        </>
    )
}

export default OrderDetailsGlobal
